/**
* Form Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Form Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'form-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.form-hero-testimonials__splide' ).length ) {
        $( '.form-hero-testimonials__splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'fade',
            rewind: true,
            paginationDirection: 'ttb',
            autoplay: true,
            interval: 5000,
            arrows: false,
            drag: false,
            perPage: 1,
            perMove: 1,
            breakpoints: {
              768: {
                paginationDirection: 'ltr',
              },
            },
          } ).mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'form-hero', COMPONENT );
} )( app );
